__turbopack_context__.v({
  "alert": "product-demos-module-scss-module__T_6xiq__alert",
  "alertDot": "product-demos-module-scss-module__T_6xiq__alertDot",
  "alertIcon": "product-demos-module-scss-module__T_6xiq__alertIcon",
  "alertList": "product-demos-module-scss-module__T_6xiq__alertList",
  "alertWrap": "product-demos-module-scss-module__T_6xiq__alertWrap",
  "analysisTitle": "product-demos-module-scss-module__T_6xiq__analysisTitle",
  "barPlot": "product-demos-module-scss-module__T_6xiq__barPlot",
  "basedOn": "product-demos-module-scss-module__T_6xiq__basedOn",
  "beta": "product-demos-module-scss-module__T_6xiq__beta",
  "chartAxis": "product-demos-module-scss-module__T_6xiq__chartAxis",
  "chartBands": "product-demos-module-scss-module__T_6xiq__chartBands",
  "chartColumn": "product-demos-module-scss-module__T_6xiq__chartColumn",
  "chartDays": "product-demos-module-scss-module__T_6xiq__chartDays",
  "chartGlow": "product-demos-module-scss-module__T_6xiq__chartGlow",
  "chartHeading": "product-demos-module-scss-module__T_6xiq__chartHeading",
  "chartPlot": "product-demos-module-scss-module__T_6xiq__chartPlot",
  "chartTools": "product-demos-module-scss-module__T_6xiq__chartTools",
  "charts": "product-demos-module-scss-module__T_6xiq__charts",
  "chatInput": "product-demos-module-scss-module__T_6xiq__chatInput",
  "coachAlert": "product-demos-module-scss-module__T_6xiq__coachAlert",
  "coachChat": "product-demos-module-scss-module__T_6xiq__coachChat",
  "coachHeader": "product-demos-module-scss-module__T_6xiq__coachHeader",
  "coachMark": "product-demos-module-scss-module__T_6xiq__coachMark",
  "compactMetrics": "product-demos-module-scss-module__T_6xiq__compactMetrics",
  "compactScore": "product-demos-module-scss-module__T_6xiq__compactScore",
  "companionActions": "product-demos-module-scss-module__T_6xiq__companionActions",
  "companionBody": "product-demos-module-scss-module__T_6xiq__companionBody",
  "companionFooter": "product-demos-module-scss-module__T_6xiq__companionFooter",
  "companionInsight": "product-demos-module-scss-module__T_6xiq__companionInsight",
  "companionMessage": "product-demos-module-scss-module__T_6xiq__companionMessage",
  "companionScene": "product-demos-module-scss-module__T_6xiq__companionScene",
  "companionThread": "product-demos-module-scss-module__T_6xiq__companionThread",
  "companionTitle": "product-demos-module-scss-module__T_6xiq__companionTitle",
  "comparisonConversation": "product-demos-module-scss-module__T_6xiq__comparisonConversation",
  "demoCursor": "product-demos-module-scss-module__T_6xiq__demoCursor",
  "demoCursorIcon": "product-demos-module-scss-module__T_6xiq__demoCursorIcon",
  "drawdownActions": "product-demos-module-scss-module__T_6xiq__drawdownActions",
  "findings": "product-demos-module-scss-module__T_6xiq__findings",
  "gainBar": "product-demos-module-scss-module__T_6xiq__gainBar",
  "genericAnswer": "product-demos-module-scss-module__T_6xiq__genericAnswer",
  "genericChat": "product-demos-module-scss-module__T_6xiq__genericChat",
  "genericHeader": "product-demos-module-scss-module__T_6xiq__genericHeader",
  "heatHours": "product-demos-module-scss-module__T_6xiq__heatHours",
  "heatRow": "product-demos-module-scss-module__T_6xiq__heatRow",
  "lineMarker": "product-demos-module-scss-module__T_6xiq__lineMarker",
  "liveScene": "product-demos-module-scss-module__T_6xiq__liveScene",
  "liveWindow": "product-demos-module-scss-module__T_6xiq__liveWindow",
  "lossBar": "product-demos-module-scss-module__T_6xiq__lossBar",
  "losses": "product-demos-module-scss-module__T_6xiq__losses",
  "media": "product-demos-module-scss-module__T_6xiq__media",
  "messageAuthor": "product-demos-module-scss-module__T_6xiq__messageAuthor",
  "metrics": "product-demos-module-scss-module__T_6xiq__metrics",
  "morningChart": "product-demos-module-scss-module__T_6xiq__morningChart",
  "morningOverview": "product-demos-module-scss-module__T_6xiq__morningOverview",
  "morningPanels": "product-demos-module-scss-module__T_6xiq__morningPanels",
  "morningScene": "product-demos-module-scss-module__T_6xiq__morningScene",
  "morningScroll": "product-demos-module-scss-module__T_6xiq__morningScroll",
  "morningTabs": "product-demos-module-scss-module__T_6xiq__morningTabs",
  "morningTitle": "product-demos-module-scss-module__T_6xiq__morningTitle",
  "negative": "product-demos-module-scss-module__T_6xiq__negative",
  "noAccess": "product-demos-module-scss-module__T_6xiq__noAccess",
  "performanceAxis": "product-demos-module-scss-module__T_6xiq__performanceAxis",
  "performanceChart": "product-demos-module-scss-module__T_6xiq__performanceChart",
  "performanceTooltip": "product-demos-module-scss-module__T_6xiq__performanceTooltip",
  "person": "product-demos-module-scss-module__T_6xiq__person",
  "playback": "product-demos-module-scss-module__T_6xiq__playback",
  "positive": "product-demos-module-scss-module__T_6xiq__positive",
  "powered": "product-demos-module-scss-module__T_6xiq__powered",
  "productWindow": "product-demos-module-scss-module__T_6xiq__productWindow",
  "receipts": "product-demos-module-scss-module__T_6xiq__receipts",
  "reviewColumns": "product-demos-module-scss-module__T_6xiq__reviewColumns",
  "reviewDaily": "product-demos-module-scss-module__T_6xiq__reviewDaily",
  "reviewDay": "product-demos-module-scss-module__T_6xiq__reviewDay",
  "reviewFocus": "product-demos-module-scss-module__T_6xiq__reviewFocus",
  "reviewGain": "product-demos-module-scss-module__T_6xiq__reviewGain",
  "reviewLoss": "product-demos-module-scss-module__T_6xiq__reviewLoss",
  "reviewPanels": "product-demos-module-scss-module__T_6xiq__reviewPanels",
  "reviewScene": "product-demos-module-scss-module__T_6xiq__reviewScene",
  "reviewSummary": "product-demos-module-scss-module__T_6xiq__reviewSummary",
  "reviewTabs": "product-demos-module-scss-module__T_6xiq__reviewTabs",
  "reviewTrend": "product-demos-module-scss-module__T_6xiq__reviewTrend",
  "reviewWhen": "product-demos-module-scss-module__T_6xiq__reviewWhen",
  "reviewWindow": "product-demos-module-scss-module__T_6xiq__reviewWindow",
  "scene": "product-demos-module-scss-module__T_6xiq__scene",
  "score": "product-demos-module-scss-module__T_6xiq__score",
  "scoreCard": "product-demos-module-scss-module__T_6xiq__scoreCard",
  "scoreFill": "product-demos-module-scss-module__T_6xiq__scoreFill",
  "scoreLabel": "product-demos-module-scss-module__T_6xiq__scoreLabel",
  "scoreMax": "product-demos-module-scss-module__T_6xiq__scoreMax",
  "scoreMin": "product-demos-module-scss-module__T_6xiq__scoreMin",
  "scoreNeedle": "product-demos-module-scss-module__T_6xiq__scoreNeedle",
  "scoreReveal": "product-demos-module-scss-module__T_6xiq__scoreReveal",
  "scoreTrack": "product-demos-module-scss-module__T_6xiq__scoreTrack",
  "scoreValue": "product-demos-module-scss-module__T_6xiq__scoreValue",
  "tradingLine": "product-demos-module-scss-module__T_6xiq__tradingLine",
  "userMessage": "product-demos-module-scss-module__T_6xiq__userMessage",
  "video": "product-demos-module-scss-module__T_6xiq__video",
  "windowHeading": "product-demos-module-scss-module__T_6xiq__windowHeading",
  "wins": "product-demos-module-scss-module__T_6xiq__wins",
  "workflowScene": "product-demos-module-scss-module__T_6xiq__workflowScene",
});
